import {FC} from "react";
import {NavLink} from "react-router-dom";

interface Props {
    to:string
}

const ListNavItem: FC<Props> = (props) => {
    return (
        <li className='listnav'>
            <NavLink to={props.to} className='w-full block p-2 transition-colors hover:bg-secondary/50'>
                {props.children}
            </NavLink>
        </li>
    );
};

export default ListNavItem;